import { FC, SyntheticEvent, useState } from 'react'
import axios from 'axios'
import Swal from 'sweetalert2'
import { useNavigate } from 'react-router-dom'
import BenchmarkRecordsTable from './BenchmarkRecordsTable'
import { BenchmarkRecordEditModal } from './BenchmarkRecordEditModal'
const BenchmarkRecordsList: FC = () => {
  const [itemIdForUpdate, setItemIdForUpdate] = useState('')
  const [itemIdForView, setItemIdForView] = useState('')
  const [refreshFunction, setRefreshFunction] = useState<any>(() => {})
  const navigate = useNavigate()
  return (
    <>
      <BenchmarkRecordsTable
        title='Benchmark Views'
        dataUrl='/benchmark_records/list'
        editCallback={(id: any, refresh: Function) => {
          setRefreshFunction(() => refresh)
          setItemIdForUpdate(id)
        }}
        deleteCallback={(id: any, refresh: Function) => {
          axios.get('/benchmark_records/save/' + id).then((response) => {
            let csrfData = response.data.data
            Swal.fire({
              title: 'Warning',
              html: 'Are you want to delete this document?',
              icon: 'warning',
              showCancelButton: true,
              confirmButtonText: 'Delete',
              cancelButtonText: 'Cancel',
              customClass: {
                confirmButton: 'btn btn-danger',
                cancelButton: 'btn btn-primary',
              },
            }).then((result) => {
              if (result.isConfirmed) {
                axios
                  .delete('benchmark_records/save/' + id, {
                    data: csrfData,
                  })
                  .then(() => {
                    refresh()
                  })
              }
            })
          })
        }}
        actionItems={[
          {
            text: 'New Benchmark View',
            class: 'btn btn-sm btn-primary',
            icon: 'fa fa-plus',
            onClick: function (event: SyntheticEvent, refresh: Function) {
              setItemIdForUpdate('add')
              setRefreshFunction(() => refresh)
            },
          },
        ]}
        //@ts-ignore
        viewCallback={(id: any, refresh: Function) => {
          setRefreshFunction(() => refresh)
          setItemIdForView(id)
        }}
      />
      {itemIdForUpdate !== '' ? (
        <BenchmarkRecordEditModal
          show={itemIdForUpdate !== ''}
          itemIdForUpdate={itemIdForUpdate}
          onHide={() => {
            setItemIdForUpdate('')
          }}
          refreshFunction={(itemId: any) => {
            if (itemId !== undefined) {
              setItemIdForUpdate(itemId)
            }
            refreshFunction()
          }}
        />
      ) : (
        <></>
      )}
      {itemIdForView !== 'add' && itemIdForView !== '' ? (
        navigate('/benchmark/records/edit/' + itemIdForView)
      ) : (
        <></>
      )}
    </>
  )
}

export { BenchmarkRecordsList }
